export const formIdObject = {
    devForm: "developmentForm",
    designForm: "designForm",
    salesForm: "bdSalesForm",
    pmForm: "projectManagementForm",
};
